/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponse,
  PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams,
  PostApiV1IndividualpaymentParcelsParcelidReintegrateQueryParams,
  PostApiV1IndividualpaymentParcelsParcelidReintegrate401,
  PostApiV1IndividualpaymentParcelsParcelidReintegrate404,
  PostApiV1IndividualpaymentParcelsParcelidReintegrate500,
} from "../../types/individualPaymentOperationsController/PostApiV1IndividualpaymentParcelsParcelidReintegrate.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1IndividualpaymentParcelsParcelidReintegrate } from "../../clients/individualPaymentOperationsController/postApiV1IndividualpaymentParcelsParcelidReintegrate.ts";

export const postApiV1IndividualpaymentParcelsParcelidReintegrateMutationKey =
  () =>
    [
      { url: "/api/v1/individualpayment/parcels/:parcelId/reintegrate" },
    ] as const;

export type PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationKey =
  ReturnType<
    typeof postApiV1IndividualpaymentParcelsParcelidReintegrateMutationKey
  >;

export function postApiV1IndividualpaymentParcelsParcelidReintegrateMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1IndividualpaymentParcelsParcelidReintegrateMutationKey();
  return mutationOptions<
    PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate401
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate404
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidReintegrateQueryParams;
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ parcelId, params }) => {
      return postApiV1IndividualpaymentParcelsParcelidReintegrate(
        parcelId,
        params,
        config,
      );
    },
  });
}

/**
 * @description Migrado do legado IndividualPayment/ActivateReintegrateParcel. **(Requer Authorization para autenticação)**
 * @summary Marca a parcela para reintegração com o serial informado (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/reintegrate}
 */
export function usePostApiV1IndividualpaymentParcelsParcelidReintegrate<
  TContext,
>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidReintegrate401
        | PostApiV1IndividualpaymentParcelsParcelidReintegrate404
        | PostApiV1IndividualpaymentParcelsParcelidReintegrate500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams["parcelId"];
        params?: PostApiV1IndividualpaymentParcelsParcelidReintegrateQueryParams;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1IndividualpaymentParcelsParcelidReintegrateMutationKey();

  const baseOptions =
    postApiV1IndividualpaymentParcelsParcelidReintegrateMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponse,
      ResponseErrorConfig<
        | PostApiV1IndividualpaymentParcelsParcelidReintegrate401
        | PostApiV1IndividualpaymentParcelsParcelidReintegrate404
        | PostApiV1IndividualpaymentParcelsParcelidReintegrate500
      >,
      {
        parcelId: PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams["parcelId"];
        params?: PostApiV1IndividualpaymentParcelsParcelidReintegrateQueryParams;
      },
      TContext
    >;

  return useMutation<
    PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate401
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate404
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidReintegrateQueryParams;
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1IndividualpaymentParcelsParcelidReintegrateMutationResponse,
    ResponseErrorConfig<
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate401
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate404
      | PostApiV1IndividualpaymentParcelsParcelidReintegrate500
    >,
    {
      parcelId: PostApiV1IndividualpaymentParcelsParcelidReintegratePathParams["parcelId"];
      params?: PostApiV1IndividualpaymentParcelsParcelidReintegrateQueryParams;
    },
    TContext
  >;
}
